import { render } from "./TypingLoader.vue?vue&type=template&id=8aa0aa2c&scoped=true&ts=true"
import script from "./TypingLoader.vue?vue&type=script&lang=ts"
export * from "./TypingLoader.vue?vue&type=script&lang=ts"

import "./TypingLoader.vue?vue&type=style&index=0&id=8aa0aa2c&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aa0aa2c"]])

export default __exports__